import { SiteSettings } from '@/types';

// Fallbacks used when /api/settings is unreachable.
// Must mirror the seeded values in worker/src/db/migrations/2026-06-10_subscribers_settings.sql
export const DEFAULT_SETTINGS: SiteSettings = {
    socialYoutube: 'https://www.youtube.com/@Maximum.Productions',
    socialInstagram: 'https://www.instagram.com/maximum.prod',
    socialTiktok: 'https://www.tiktok.com/@maximum.prod',
    socialTwitter: 'https://www.x.com/mxmprod',
    socialPatreon: 'https://www.patreon.com/',
    pressEmail: 'press@thismx.com',
    contactEmail: 'hello@thismx.com',
    eternityKeyArt: '',
    eternityLaurels: [],
    eternityStills: [],
};
